import { parseCampaignMessage } from 'services/campaignMessagesServices';

import { axiosWithToken } from './axios';

export const fetchAddCampaignMessage = async ({
  campaignId,
  message,
  attachmentUrl,
  username,
}) => {
  const response = await axiosWithToken.post(`campaign/message`, {
    campaign_id: campaignId,
    message,
    attachments_url: attachmentUrl,
  });

  const newMessage = JSON.parse(response.data.body).message[0];

  return parseCampaignMessage(newMessage, username);
};

export const fetchGetCampaignMessages = async ({ username, campaignId }) => {
  const response = await axiosWithToken.get(`campaign/message`, {
    params: {
      campaign_id: campaignId,
    },
  });

  const { messages } = JSON.parse(response.data.body);

  return messages.map((message) => parseCampaignMessage(message, username));
};
